import { render, staticRenderFns } from "./registration-page.vue?vue&type=template&id=6ac51716&"
import script from "./registration-page.vue?vue&type=script&lang=js&"
export * from "./registration-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\OSPanel\\domains\\specialty.local\\local\\js\\specialty\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ac51716')) {
      api.createRecord('6ac51716', component.options)
    } else {
      api.reload('6ac51716', component.options)
    }
    module.hot.accept("./registration-page.vue?vue&type=template&id=6ac51716&", function () {
      api.rerender('6ac51716', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/registration/registration-page.vue"
export default component.exports